import {
  Button,
  Flex,
  Text,
  useMediaQuery,
  Skeleton,
  SkeletonText,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { toast } from "react-toastify";

const STATUS_LABELS = {
  PENDENTE: "Pendente",
  CONFIRMADO: "Confirmado",
  CANCELADO: "Cancelado",
  FINALIZADO: "Finalizado",
  SEPARADO: "Separado",
  ENVIADO: "Enviado",
};

// Pendente mantém o estilo padrão do Button (colorScheme).
const STATUS_COLOR_SCHEMES = {
  PENDENTE: "orange",
};

// Demais status usam cor de fundo fixa.
const STATUS_COLORS = {
  FINALIZADO: "#1AB744",
  SEPARADO: "#EDB929",
  CANCELADO: "#C01B0D",
  ENVIADO: "#298186",
  CONFIRMADO: "#2998D4",
};

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const navigate = useNavigate();

  useEffect(() => {
    const getOrders = async () => {
      try {
        setLoading(true);
        const response = await api.get("/orders");
        setOrders(response.data);
      } catch (err) {
        if (err.response?.status !== 401) {
          toast.error(
            "Não foi possível buscar os seus pedidos, entre em contato com o suporte.",
          );
        }
      } finally {
        setLoading(false);
      }
    };

    getOrders();
  }, []);

  return (
    <Flex
      width="100%"
      padding="15px"
      justifyContent="center"
      minH="100vh"
      paddingTop={isLargerThan768 ? "100px" : "120px"}
    >
      <Flex
        maxW={isLargerThan768 ? "1200px" : "100%"}
        width="100%"
        flexDirection="column"
        gap="20px"
      >
        {loading
          ? // 🔹 Skeletons — mostra 3 blocos de carregamento
            Array.from({ length: 3 }).map((_, index) => (
              <Flex
                key={index}
                width="100%"
                padding="15px"
                borderRadius="8px"
                justifyContent="space-between"
                alignItems="center"
                border="1px solid #ececec"
              >
                <Flex flexDirection="column" gap="6px" width="70%">
                  <Skeleton height="16px" width="60%" />
                  <Skeleton height="18px" width="40%" />
                  <Skeleton height="14px" width="50%" />
                </Flex>
                <Skeleton height="36px" width="100px" borderRadius="6px" />
              </Flex>
            ))
          : // 🔹 Lista real de pedidos
            orders.map(
              ({ totalValue, order_number, createdAt, id, status }) => {
                const formattedDate = new Intl.DateTimeFormat("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(new Date(createdAt));

                const formattedValue = new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(totalValue);

                return (
                  <Flex
                    key={order_number}
                    width="100%"
                    padding="15px"
                    borderRadius="8px"
                    justifyContent="space-between"
                    alignItems="center"
                    border="1px solid #ececec"
                    onClick={() => navigate(`/pedido/${id}`)}
                  >
                    <Flex flexDirection="column">
                      <Text>{formattedDate}</Text>
                      <Text fontWeight="700">{formattedValue}</Text>
                      <Text>N°: {order_number ?? "-"}</Text>
                    </Flex>
                    <Button
                      padding="10px 15px"
                      colorScheme={STATUS_COLOR_SCHEMES[status] || "gray"}
                      bg={STATUS_COLORS[status]}
                      color={STATUS_COLORS[status] ? "white" : undefined}
                      _hover={
                        STATUS_COLORS[status]
                          ? { bg: STATUS_COLORS[status], opacity: 0.9 }
                          : undefined
                      }
                    >
                      {STATUS_LABELS[status] || status}
                    </Button>
                  </Flex>
                );
              },
            )}
      </Flex>
    </Flex>
  );
}
